<template>
  <div class="locale-switcher d-flex gap-2 mb-3">
    <button
      v-for="loc in availableLocales"
      :key="loc.code"
      @click="switchLocale(loc.code)"
      :class="['btn', 'btn-sm', loc.code === locale ? 'btn-primary' : 'btn-link link-light']"
      :aria-label="`Switch to ${loc.name}`"
    >
      {{ loc.name }}
    </button>
  </div>
</template>

<script setup lang="ts">
const { locale, locales, setLocale } = useI18n()

const availableLocales = computed(() => locales.value)

const switchLocale = async (code: string) => {
  await setLocale(code)
}
</script>

<style scoped lang="scss">
// .locale-switcher {
//   .btn {
//     min-width: 70px;
//   }
// }
</style>
